export default __webpack_public_path__ + "static/media/seo-call.ed82c6ca.wav";